export default "__VITE_ASSET__D_Ks_QCm__"